module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('div', {
    staticClass: "col-xs-12 m-b-10"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'MenuSettingRuleStoreCopyView',
        params: {
          brand_id: _vm.$route.params.brand_id
        }
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n          返回菜單同步權限設定\n        ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [(_vm.list) ? _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(item, i) {
    return _c('tr', {
      key: _vm.list.id
    }, [_c('td', {
      staticClass: "w-xs"
    }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('td', {
      staticClass: "w-sm"
    }, [_vm._v(_vm._s(item.manager_account))]), _vm._v(" "), _c('td', {
      staticClass: "w-md"
    }, [_vm._v(_vm._s(_vm.moment(item.action_time).format('YYYY/MM/DD HH:mm:ss')))]), _vm._v(" "), _c('td', {
      staticClass: "w-auto"
    }, [_c('div', {
      staticClass: "mb-1"
    }, [_vm._v("新增：" + _vm._s(_vm.handleName(item.action.add)))]), _vm._v(" "), _c('div', {
      staticClass: "mb-1"
    }, [_vm._v("移除：" + _vm._s(_vm.handleName(item.action.remove)))]), _vm._v(" "), _c('div', [_vm._v("結果：" + _vm._s(_vm.handleName(item.action.result)))])])])
  }), 0)]) : _vm._e()])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("帳號名稱")]), _vm._v(" "), _c('th', [_vm._v("時間")]), _vm._v(" "), _c('th', [_vm._v("門市（新增、移除、結果）")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a12fbaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/MenuSettingRuleStoreCopyLogs.vue
// module id = 2514
// module chunks = 1